import { CreateFormRowTypes } from './types';

import cn from './create.module.css';

const CreateFormRow = ({ title, children, id }: CreateFormRowTypes) => (
  <div className={cn.formRow} id={id}>
    <div className={cn.formRowTitle}>{title}</div>
    <div className={cn.formRowContent}>{children}</div>
  </div>
);

export default CreateFormRow;
